<template>
    <div style="min-height: 700px">
        <div class="card my-3">
            <div class="card-header">
                反馈模板信息与规则
            </div>
            <div class="card-body">
                <div class="form-group row">
                    <label for="inputSurveyTemplateName" class="col-sm-3 col-form-label text-right">模板名称</label>
                    <div class="col-sm-8">
                        <input type="text" class="form-control" id="inputSurveyTemplateName" placeholder="模板名称"
                               v-model="surveyTemplateInfo.surveyTemplateName">
                    </div>
                </div>
                <div class="form-group row">
                    <label for="inputSurveyTemplateType" class="col-sm-3 col-form-label text-right">模板类型</label>
                    <div class="col-sm-8">
                        <select class="form-control" id="inputSurveyTemplateType"
                                v-model="surveyTemplateInfo.surveyTemplateType">
                            <option v-for="code in surveyTemplateTypeEnum" :key="code.codeValue" :value="code.codeValue">{{code.codeContent}}</option>
                        </select>
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-sm-3 col-form-label text-right">计算规则</label>
                    <label for="inputExcludeMaxCount" class="col-sm-2 col-form-label text-left">去掉几个最高分：</label>
                    <div class="col-sm-2">
                        <input type="number" class="form-control" id="inputExcludeMaxCount"
                               v-model.number="surveyTemplateInfo.excludeMaxCount">
                    </div>
                    <label for="inputExcludeMinCount" class="col-sm-2 col-form-label text-left">去掉几个最低分：</label>
                    <div class="col-sm-2">
                        <input type="number" class="form-control" id="inputExcludeMinCount"
                               v-model.number="surveyTemplateInfo.excludeMinCount">
                    </div>
                </div>
                <div class="form-group row">
                    <div class="col-sm-8 offset-3 option-padding-top">
                        <div class="form-check">
                            <input class="form-check-input" type="checkbox" id="inputAllowAllFullScore" v-model="surveyTemplateInfo.allowAllFullScore">
                            <label class="form-check-label" for="inputAllowAllFullScore">允许反馈打分为满分</label>
                        </div>
                    </div>
                </div>
                <div class="form-group row mb-0">
                    <div class="col-sm-4 offset-3 option-padding-top">
                        <div class="form-check">
                            <input class="form-check-input" type="checkbox" id="inputRequiredLessThenMinScore" v-model="surveyTemplateInfo.requiredLessThenMinScore">
                            <label class="form-check-label" for="inputRequiredLessThenMinScore">低分反馈必须填写原因</label>
                        </div>
                    </div>
                    <label for="inputMinScore" class="col-sm-2 col-form-label text-left" v-if="surveyTemplateInfo.requiredLessThenMinScore">低于满分的百分比：</label>
                    <div class="col-sm-2" v-if="surveyTemplateInfo.requiredLessThenMinScore">
                        <input type="number" class="form-control" id="inputMinScore"
                               v-model.number="surveyTemplateInfo.minScore">
                    </div>
                </div>
            </div>
            <div class="card-footer text-center">
                <button class="btn btn-primary">保存</button>
            </div>
        </div>

        <div class="card my-3">
            <div class="card-header">
                <div class="row">
                    <div class="col-6">反馈模板反馈项信息管理</div>
                    <div class="col-6 text-right">客观项合计总分：{{totalScore}}</div>
                </div>
            </div>
            <div class="card-body" v-if="surveyTemplateItemData.length===0">
                <div class="alert alert-warning mb-0">没有具体评价内容，请添加</div>
            </div>
            <table v-else class="table table-bordered mb-0">
                <thead>
                <tr>
                    <th class="text-center align-middle" style="width: 10%">序号</th>
                    <th class="text-center align-middle" style="width: 60%">内容</th>
                    <th class="text-center align-middle" style="width: 10%">类型</th>
                    <th class="text-center align-middle" style="width: 10%">分值</th>
                    <th class="text-center align-middle" style="width: 10%">编辑</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(content, index) in surveyTemplateItemData" :key="content.surveyTemplateItemId">
                    <td class="text-center align-middle">{{index+1}}</td>
                    <td class="text-left align-middle">{{content.surveyTemplateItem}}</td>
                    <td class="text-center align-middle">{{content.surveyTemplateItemTypeName}}</td>
                    <td class="text-center align-middle">{{content.surveyTemplateItemType===1? content.maxScore: ''}}</td>
                    <td class="text-center align-middle">
                        <button class="btn btn-danger btn-sm" @click="btnDeleteEvaluateInfo_Click(content.surveyTemplateItemId)">删除</button>
                    </td>
                </tr>
                </tbody>
            </table>
            <div class="card-footer text-center">
                <button class="btn btn-primary" @click="btnAddSurveyTemplateItemInfo_Click">添加评价内容</button>
            </div>
        </div>

        <b-modal v-model="isAddSurveyTemplateItemInfoDialogOpen"
                 title="添加反馈项内容"
                 ok-title="确定" cancel-title="取消" @ok="addSurveyTemplateItemInfoDialog_OK"
                 :no-close-on-backdrop="true">
            <div class="form-group row">
                <label for="inputSurveyTemplateItem" class="col-sm-3 col-form-label text-right">评价内容</label>
                <div class="col-sm-8">
                    <input type="text" class="form-control" id="inputSurveyTemplateItem" placeholder="评价内容"
                           v-model="addSurveyTemplateItemInfo.surveyTemplateItem">
                </div>
            </div>
            <div class="form-group row" :class="{'mb-0': addSurveyTemplateItemInfo.surveyTemplateItemType===surveyTemplateItemType.V2_CONTENT}">
                <label for="inputContentType" class="col-sm-3 col-form-label text-right">内容类型</label>
                <div class="col-sm-8">
                    <select class="form-control" id="inputContentType"
                            v-model="addSurveyTemplateItemInfo.surveyTemplateItemType">
                        <option v-for="code in surveyTemplateItemTypeEnum" :key="code.codeValue" :value="code.codeValue">{{code.codeContent}}</option>
                    </select>
                </div>
            </div>
            <div class="form-group row mb-0" v-if="addSurveyTemplateItemInfo.surveyTemplateItemType===surveyTemplateItemType.V1_SCORE">
                <label for="inputScore" class="col-sm-3 col-form-label text-right">最高分：</label>
                <div class="col-sm-3">
                    <input type="number" class="form-control" id="inputScore"
                           v-model.number="addSurveyTemplateItemInfo.maxScore">
                </div>
            </div>
        </b-modal>
    </div>
</template>

<script>
import dictionary from "@/utils/dictionary";
import baseApi from "@/utils/api/base";
import studyApi from "@/utils/api/study";

export default {
    name: "AdminSurveyTemplateEdit",
    data: function () {
        return {
            surveyTemplateId: this.$route.params.surveyTemplateId,
            surveyTemplateItemType: dictionary.surveyTemplateItemType,

            surveyTemplateTypeEnum: [],
            surveyTemplateItemTypeEnum: [],

            surveyTemplateInfo: {},

            surveyTemplateItemData: [],

            addSurveyTemplateItemInfo: {
                surveyTemplateItemId: '',
                surveyTemplateId: this.surveyTemplateId,
                surveyTemplateItem: '',
                surveyTemplateItemType: 1,
                maxScore: 10
            },
            isAddSurveyTemplateItemInfoDialogOpen: false
        };
    },
    computed: {
        totalScore() {
            let result = 0;
            for (let item of this.surveyTemplateItemData) {
                if (item.surveyTemplateItemType === 1) {
                    result += item.maxScore;
                }
            }
            return result;
        }
    },
    mounted() {
        this.getSurveyTemplateTypeEnum();
        this.getSurveyTemplateItemTypeEnum();

        this.getSurveyTemplateInfo();
        this.getSurveyTemplateItemData();
    },
    methods: {
        getSurveyTemplateTypeEnum() {
            baseApi.codeValue.getSurveyTemplateTypeEnum().then(res => {
                this.surveyTemplateTypeEnum = res.data;
            });
        },
        getSurveyTemplateItemTypeEnum() {
            baseApi.codeValue.getSurveyTemplateItemTypeEnum().then(res => {
                this.surveyTemplateItemTypeEnum = res.data;
            });
        },

        getSurveyTemplateInfo() {
            studyApi.survey.template.getSurveyTemplateInfo(this.surveyTemplateId).then(res => {
                this.surveyTemplateInfo = res.data;
            });
        },
        btnSaveSurveyTemplateInfo_Click() {
            studyApi.survey.template.updateSurveyTemplateState(this.surveyTemplateInfo).then(res => {
                this.getSurveyTemplateInfo();
            });
        },

        getSurveyTemplateItemData() {
            studyApi.survey.template.item.getSurveyTemplateItemData(this.surveyTemplateId).then(res => {
                this.surveyTemplateItemData = res.data;
            });
        },

        btnAddSurveyTemplateItemInfo_Click() {
            this.addSurveyTemplateItemInfo = {
                surveyTemplateItemId: '',
                surveyTemplateId: this.surveyTemplateId,
                surveyTemplateItem: '',
                surveyTemplateItemType: 1,
                maxScore: 10
            };
            this.isAddSurveyTemplateItemInfoDialogOpen = true;
        },
        addSurveyTemplateItemInfoDialog_OK() {
            studyApi.survey.template.item.insertSurveyTemplateItemInfo(this.addSurveyTemplateItemInfo).then(res => {
                this.getSurveyTemplateItemData();
            });
        },
        btnDeleteEvaluateInfo_Click(surveyTemplateItemId) {
            if (confirm('是否删除此项评价内容？')) {
                studyApi.survey.template.item.deleteSurveyTemplateItemInfo(surveyTemplateItemId).then(res => {
                    this.getSurveyTemplateItemData();
                });
            }
        }
    }
}
</script>

<style scoped>

</style>